import type { FC } from "react";
import { useApiCall } from "../api/api";
import type { Company } from "../api/dto";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const UnlinkCompanyModal: FC<{
  baseCompany: Company;
  parentCompany?: Company;
  childCompany?: Company;
}> = (props) => {
  const { detachChildCompany, detachParentCompany } = useApiCall();
  const refresh = useRefresh();

  const save = async () => {
    if (props.parentCompany) {
      detachParentCompany(props.baseCompany.id, props.parentCompany.id);
    }
    if (props.childCompany) {
      detachChildCompany(props.baseCompany.id, props.childCompany.id);
    }
    refresh();
  };
  return (
    <div>
      <p>
        <strong>Let op!</strong> Weet je zeker dat dit bedrijf wilt loskoppelen van{" "}
        {props.baseCompany.name}?
      </p>
      <p>
        Dit is een <strong>permanente</strong> actie en kan niet ongedaan worden gemaakt.
      </p>
      <ModalFooter text={"Loskoppelen"} onSubmit={save} />
    </div>
  );
};
